import React from "react";
import DeskItem from "./components/DeskItem";

const Item = ({ title, state, onClick }) => {
  return <DeskItem state={state} title={title} onClick={onClick} />;
};

export default Item;
